import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDialog } from 'react-mui-dialog';
import { COLOURS, inputStyleColour, otusButtonStyleGreen } from '../variables';
import { TryActionWithCatchDialogAsync } from './Utils';

export default function DisableMfaDialog({ open, setOpen, usersClient, onValidated }) {
    const [code, setCode] = useState('');
    const [validated, setValidated] = useState(false);
    const [hasValidated, setHasValidated] = useState(false);
    const { openDialog } = useDialog();

    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        setOpen(false);
    };

    const handleValidate = async () => {
        await TryActionWithCatchDialogAsync(async () => {
            await onValidated(code);
            setOpen(false);
            setValidated(true);
        }, openDialog, (error) => {
            return error === '401' ? 'Code not valid' : null;
        });
    };

    useEffect(() => {
        if (onValidated && validated && !hasValidated) {
            setHasValidated(true);
            // Optionally, you could call onValidated here, but it's already called in handleValidate
        }
    }, [validated, hasValidated, onValidated]);

    useEffect(() => {
        if (open) {
            setValidated(false);
            setHasValidated(false);
            setCode('');
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle color={COLOURS.fontColor}>Disable Two Factor Authentication</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="MFA Code"
                    type="text"
                    onChange={(e) => setCode(e.target.value)}
                    value={code}
                    sx={inputStyleColour(COLOURS.fontColor)}
                    fullWidth
                    variant="standard"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleValidate} sx={otusButtonStyleGreen}>Disable</Button>
            </DialogActions>
        </Dialog>
    );
}
